import { Component, Input } from "@angular/core";
import { AuthenticationService } from "../../../shared/services/authentication.service";
import { Router } from "@angular/router";

declare var require:any;

@Component({
    selector: 'menu-selector-module',
    template: require('./menu-selector-module.component.html'),
    styles: [ require('./menu-selector-module.component.css')]
})

export class MenuSelectorModuleComponent {

    private selectedOption:string;
    private isOtherOption:boolean;

    constructor(public authenticationService: AuthenticationService,
                public router:Router) {

    }

    onChangeOpened(event:any) { 
        this.authenticationService.isOpenMenuModule = false;
    }

    onClickOption(option:string) {
        this.authenticationService.isOpenMenuModule = false;
        
        if ( option && option == this.selectedOption ) {
            this.isOtherOption = false;
            return;
        } else if (option && option != "undefined") {
            this.isOtherOption = true;
            this.selectedOption = option;
        }
    }

    onClosed() {
        if (this.selectedOption && this.isOtherOption) {
            this.isOtherOption = false;
            this.authenticationService.isLoading = true;
            this.router.navigate([this.selectedOption]);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/core/components/menu-selector-module/menu-selector-module.component.ts